<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>Notifications</h2>
                    </div>
                    <div class="col-lg-4 col-6 text-right bid">
                    <!-- <button  type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                    <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <!-- <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="getNotificationList()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchCustomer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>               -->
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="col-form-label">From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="col-form-label">To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="col-form-label">ECN's</label>
                      <multiselect 
                        v-model="selectedEcn" 
                        placeholder="Select" 
                        :options="ecnList" 
                        :multiple="true" 
                        :limit="4"  ></multiselect>
                    </div>
                  <button @click="getNotificationList()" type="button" class="btn btn-primary rounded ml-0">Filter</button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                scope="col" 
                                class="sort text-left"
                                >Bid Id</th>
                                <th 
                                scope="col" 
                                class="sort text-left"
                                >Cusip</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >QTY / <br> Min Qty</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >ECN</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >Bid <br> Price</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >Bid Ordered <br> Price</th>
                                <th 
                                scope="col" 
                                class=" text-center"
                                >Ordered <br> Quantity</th>
                                <th 
                                scope="col" 
                                class=" text-center"
                                >Status</th>
                            </tr>
                            </thead>  
                            <tbody class="list">
                                <tr >
                                    <td v-if="bids.length == 0 && !loading" colspan="5"><p class="nodata n">No data available</p>
                                    </td>
                                    <td v-if="loading">
                                        <div class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                    </td>
                                </tr>
                                <tr v-for="bid in bids" :key="bid.id">
                                    <td class="text-left">{{bid.id}}</td>
                                    <td class="text-left cusips">{{bid.cusip}}</td>
                                    <td class="text-center">{{bid.quantity}} / {{bid.minQuantity}}</td>
                                    <td class="text-center">{{bid.ecn}}</td>
                                    <td class="text-center">{{bid.amount | currency}}</td>
                                    <td class="text-center" v-bind:class="{'text-danger': bid.filledAmount != bid.amount }" >{{bid.filledAmount | currency}}</td>
                                    <td 
                                        class="text-center"
                                        v-bind:class="{'text-danger': checkMinMaxRangeExceed(bid.filledQuantity,bid.minQuantity,bid.quantity)}" >
                                        {{bid.filledQuantity}}</td>
                                    <td class="text-center">
                                      {{bid.status}}
                                    </td>    
                                </tr>
                            
                            </tbody>
                        </table> 
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getNotificationList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        bids:[],
        fromDate : "",
        toDate : "",
        showFilters : false,
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        ecnList : ["IBP","TMC","TWD"],
        selectedEcn :  [],
    };
  },
  methods: {
    searchOffer(){
      this.getNotificationList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getNotificationList(); 
    },
    getNotificationList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken()  }
      };
      var subId = (!this.isAdmin && this.isTrader) ? this.cognitoSub : "";
      var fDate = this.moment(this.moment(this.fromDate).format("YYYY-MM-DD")).utc().format("YYYY-MM-DD HH:mm:ss");
      var tDate = this.moment(this.moment(this.toDate).format("YYYY-MM-DD")).add(1,"days").utc().format("YYYY-MM-DD HH:mm:ss");
      var ecns = this.selectedEcn.length == 0 ? ["IBP","TMC","TWD"] : this.selectedEcn
     // console.log(fDate);
     //https://cqtsm1unh8.execute-api.us-east-1.amazonaws.com/dev-env/bid-alerts/list?status=UNREAD,READ,CLEAR&cognitoSub=d3001632-e248-420e-8919-5bfbb7ec1cb0&fromDate=2021-10-15 18:30:00&toDate=2021-10-19 18:30:00
      var url = "/bid-alerts/list?page=" +
                  currentPage +
                  "&size=" +
                  this.perPage +
                  "&search=" +
                  this.searchValue +
                  "&status=READ,UNREAD,CLEAR,CLEARED,TWDCLEAR,TIMEOUT,DISABLED"+
                  "&fromDate="+
                  fDate+
                  "&toDate="+
                  tDate+
                  "&ecn="+
                  ecns.map((e) => {return e}).toString() 
      if(subId){
         url +="&cognitoSub="+subId;        
      }            
      this.$http
        .get(
          config.baseUrlBidSide + url,
            auth
        )
        .then(result => {
          console.log(result);
          this.loading = false;
          this.totalRows = result.data.pageInfo.totalElements;
          this.bids = result.data.content;  
        })
        .catch(() => {
          this.loading = false;
        });
    },
    checkMinMaxRangeExceed(VALUE,MIN,MAX){
      if (VALUE >= MIN && VALUE <= MAX) { 
        return false;
      }
      else{
        return true;
      }
    }
   
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            this.tenantName = role[0].split("-")[0];
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
            roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
            roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
            roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
            this.cognitoSub = authService.getUser().cognitoSub;
            this.fromDate = this.moment().subtract(1,'days').format("YYYY-MM-DD");
            this.toDate = this.moment().add(2,'days').format("YYYY-MM-DD");
            this.getNotificationList();
          }
        });
        
        
      }
    });
    

  }
};
</script>